import type { RouteLocationRaw } from "vue-router";
import type { IconName } from "../icon";

export enum ButtonType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  TERTIARY = "tertiary",
  QUATERNARY = "quaternary",
  AI = "ai",
}

export enum ButtonVariant {
  DEFAULT = "default",
  ELEVATED = "elevated",
  DASHED = "dashed",
  OUTLINE = "outline",
  PLAIN = "plain",
}

export enum ButtonSize {
  EXTRA_SMALL = "xs",
  SMALL = "sm",
  MEDIUM = "md",
}

interface AnchorElementProps {
  as: Extract<keyof HTMLElementTagNameMap, "a">;
  href?: string;
  to?: RouteLocationRaw;
}

interface ButtonElementProps {
  as: Extract<keyof HTMLElementTagNameMap, "button">;
}

interface ButtonBaseProps {
  as?: Extract<keyof HTMLElementTagNameMap, "a" | "button">;
  type?: ButtonType;
  variant?: ButtonVariant;
  size?: ButtonSize;
  isFullWidth?: boolean;
  isDisabled?: boolean;
  prefixIcon?: IconName;
  icon?: IconName;
  isVertical?: boolean;
  isLoading?: boolean;
  isSubmit?: boolean;
  to?: RouteLocationRaw;
  href?: string;
}

export type ButtonProps = ButtonBaseProps &
  (ButtonElementProps | AnchorElementProps);

export interface ButtonEmits {
  (e: "click", event: MouseEvent): void;
}
